import { UpdateGfStoreDto, GfStore } from "@swagger/typescript-fetch-goflyer";
import { toastError } from "../utils/pageUtil/toast";
import { messages } from "../locales/messages";
import { adminApiService } from "../utils/api";
import i18n from "i18next";
import { useLoading } from "../contextApi/LoadingContext";
import { useAuthHeaders } from "./useAuthHeaders";

export const useHandleSaveOnboardingStore = () => {
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  const handleSaveOnboardingStore = async (
    storeData?: UpdateGfStoreDto
  ): Promise<GfStore | null> => {
    try {
      // Validation - Required fields for store
      if (!storeData?.location?.coordinates?.[0]) {
        toastError(
          `${i18n.t(messages.longitude())} ${i18n.t(messages.is_Empty())}`
        );
        return null;
      }
      if (!storeData?.location?.coordinates?.[1]) {
        toastError(
          `${i18n.t(messages.latitude())} ${i18n.t(messages.is_Empty())}`
        );
        return null;
      }
      if (!storeData?.phone) {
        toastError(
          `${i18n.t(messages.Phone_Number())} ${i18n.t(messages.is_Empty())}`
        );
        return null;
      }
      if (!storeData?.openTime) {
        toastError(`Open Time ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!storeData?.closeTime) {
        toastError(`Close Time ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!storeData?.saturdayOpenTime) {
        toastError(`Saturday Open Time ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!storeData?.saturdayCloseTime) {
        toastError(`Saturday Close Time ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!storeData?.sundayOpenTime) {
        toastError(`Sunday Open Time ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!storeData?.sundayClosedTime) {
        toastError(`Sunday Close Time ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!storeData?.merchant) {
        toastError(
          `${i18n.t(messages.merchant())} ${i18n.t(messages.is_Empty())}`
        );
        return null;
      }

      showLoadingScreen(true);

      console.log("Saving store data:", storeData);

      const savedStore =
        await adminApiService.gfStoreAdminControllerOnBoardingCreateOne(
          {
            ...storeData,
            location: storeData.location,
            phone: storeData.phone,
            openTime: storeData.openTime,
            closeTime: storeData.closeTime,
            saturdayOpenTime: storeData.saturdayOpenTime,
            saturdayCloseTime: storeData.saturdayCloseTime,
            sundayOpenTime: storeData.sundayOpenTime,
            sundayClosedTime: storeData.sundayClosedTime,
            merchant: storeData.merchant,
            rank: storeData.rank,
            signature: storeData.signature,
            storeTag: storeData.storeTag,
          },
          authHeaders
        );
      console.log("Store saved successfully:", savedStore);
      showLoadingScreen(false);

      return savedStore;
    } catch (error) {
      showLoadingScreen(false);

      const errorMessage = `${i18n.t(
        messages.There_is_an_error_please_Contact_Administrator()
      )}`;
      toastError(errorMessage);

      console.error("Error saving onboarding store:", error);
      return null;
    }
  };

  return handleSaveOnboardingStore;
};
